(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,1674],{

/***/ 275557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(123486);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 868728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);


var DomainExpired = function(props) {
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "vh-100 flex justify-center items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "absolute top-0 w-100 mt0 f14px black-70 h3 tr pt2 flex flex-column flex-row-ns justify-center justify-end-ns items-end items-center-ns ph3",
                children: [
                    "Log In, If you are the owner of this website",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "black ph14px pv8px ba br3 b--black-40 ml4 mt2 mt0-ns f6-ns f12px pa2 link",
                        href: "https://download.digitalshowroom.app/RequestCall",
                        children: "Log In"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "ph3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                        className: "tc flex justify-center flex-column flex-row-ns items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.store_info) === null || ref1 === void 0 ? void 0 : ref1.logo_image,
                                className: "img h3 mr0 mr3-ns"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("lable", {
                                className: "f30px",
                                children: (ref2 = props.storeInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.store_info) === null || ref3 === void 0 ? void 0 : ref3.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "f24px fw6 tc",
                        children: "Hi, We are unavailable at the moment."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "f22px fw3 tc",
                        children: [
                            " ",
                            "We will be back very soon. Inconvenience is regretted."
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DomainExpired);


/***/ }),

/***/ 123486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(477733);
/* harmony import */ var url_search_params_polyfill__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35449);
/* harmony import */ var url_search_params_polyfill__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(url_search_params_polyfill__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_getWebpageTitle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(861233);
/* harmony import */ var _utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(755847);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(331399);
/* harmony import */ var _components_DomainExpired__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(868728);
/* harmony import */ var _containers_Home__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(232997);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(268037);
/* harmony import */ var _utils_checkIfThemePreview__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(115483);
/* harmony import */ var _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(506337);














var Redirection = function(props) {
    var ref, ref1, ref2;
    (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    var allProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props), {
        storeInfo: storeInfo
    });
    var isPreview = (0,_utils_checkIfThemePreview__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var hostname = window.location.hostname || "";
        var storename = hostname.split(".")[0];
        var urlParams = new URLSearchParams(window.location.search);
        var utmSource = urlParams.get("utm_source");
        if (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("utm_source")) !== utmSource) {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("utm_source", utmSource);
        }
        if (storename.startsWith("d-temporary-")) {
            window.location = "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].APP_BASE_URL */ .Z.APP_BASE_URL, "/").concat(storename.split("-")[1], "-").concat(storename.split("-")[2], "/").concat(utmSource ? "?utm_source=".concat(utmSource) : "");
        } else if (storename.startsWith("d-")) {
            /** Uncomment for Development */ // window.location = `${config.redirect_base_url}:3006/${storename.split('-')[1]}`;
            /** uncomment for stage and prod */ window.location = "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].APP_BASE_URL */ .Z.APP_BASE_URL, "/").concat(storename.split("-")[1], "/").concat(utmSource ? "?utm_source=".concat(utmSource) : "");
        } else if (storename.startsWith("showroom")) {
            storename = window.location.pathname.split("/")[1];
            /** Uncomment for Development */ // window.location = `${config.redirect_base_url}:3006/${storename}`;
            /** uncomment for stage and prod */ window.location = "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].APP_BASE_URL */ .Z.APP_BASE_URL, "/").concat(storename, "/").concat(utmSource ? "?utm_source=".concat(utmSource) : "");
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        store: storeInfo,
        title: storeInfo && (0,_utils_getWebpageTitle__WEBPACK_IMPORTED_MODULE_12__/* .getWebpageTitle */ .e)(storeInfo, allProps.seo),
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.logo_image,
        metaDescription: (0,_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_13__/* .getMetaDescription */ .w)(storeInfo, allProps.seo),
        keywords: allProps.seo ? allProps.seo.keywords.toString() : "",
        favIcon: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.favicon,
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.logo_image,
        isCustomDomain: allProps.isCustomDomain,
        canonicalTagUrl: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_url
    }, allProps), {
        children: !isPreview && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.domain_info) === null || ref2 === void 0 ? void 0 : ref2.status) === 2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DomainExpired__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            storeInfo: storeInfo
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Home__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, allProps))
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Redirection);


/***/ }),

/***/ 861233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getWebpageTitle; }
/* harmony export */ });
/**
 * @param {object} storeInfo
 * @param {object} seoDetails
 * @return {string}
 */ var getWebpageTitle = function(storeInfo, seoDetails) {
    var ref;
    // const businessTypes = storeInfo.store_businesses;
    if (seoDetails) return seoDetails.title.value;
    var title = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.default_seo) === null || ref === void 0 ? void 0 : ref.meta_title;
    return title || "";
// let storeAddressCity = '';
// if (storeInfo?.address?.visibility === 1 && storeInfo?.address?.city)
//   storeAddressCity = `, ${storeInfo?.address?.city}`;
// return `${storeInfo?.store_info?.name}${storeAddressCity} - ${
//   businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 16
//     ? 'Real Estate Property'
//     : 'Order Online'
// }`;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6956,8388,1562,5843,6379,4814,6576,8487,1033,1399,3978,2682,3973,526,2031,9875,7909,4640,6307,2265,2919,9774,2888,179], function() { return __webpack_exec__(275557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);